import React from 'react'
import Header from './common/Header'
import { Card } from 'reactstrap'

export default function Terms() {
    return (
        <>
        <Header />
        <Card>
            <h4>
                Lorem ipsum dolor sit, amet consectetur adipisicing elit. Quos labore non nemo corporis reiciendis culpa quo. Perspiciatis esse eum nesciunt sequi explicabo, deleniti repellat minima doloremque quo iusto ipsam delectus optio unde expedita labore reprehenderit veniam molestiae inventore atque dolore beatae eius porro? Nostrum dolores sint ipsam nulla reiciendis. Quidem?
            </h4>
        </Card>

        </>
    )
}
